import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=7ad06250&scoped=true&"
import script from "./Distribution.vue?vue&type=script&lang=js&"
export * from "./Distribution.vue?vue&type=script&lang=js&"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=7ad06250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad06250",
  null
  
)

export default component.exports
import {QSelect,QIcon,QBtn,QMarkupTable} from 'quasar'
component.options.components = Object.assign({QSelect,QIcon,QBtn,QMarkupTable}, component.options.components || {})
